import React, { useEffect } from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredProductions,
  selectProductionLoading,
  selectfetchProductionLoading,
} from './store/selectors';
import { showModal } from 'Core/redux/main/slice';
import { deleteProduction, getPrinters } from './store/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';
import { actions as productionActions } from './store/slice';

const { setProduct } = productionActions;

const { PRODUCTION_ADD_EDIT } = MODAL_TYPES;

const ProductionTable = () => {
  const dispatch = useDispatch();
  const { filteredData, isLoading } = useSelector(state => ({
    filteredData: selectFilteredProductions(state),
    isLoading: selectProductionLoading(state) || selectfetchProductionLoading(state),
  }));

  const handleEditClick = record => {
    dispatch(setProduct(record));
    dispatch(getPrinters());
    dispatch(showModal(PRODUCTION_ADD_EDIT, record));
  };

  const handleDeleteClick = id => {
    dispatch(deleteProduction(id));
  };

  const handleCheckboxChange = (e, record) => {
    // Handle checkbox change logic here
    console.log('Checkbox changed', record, e.target.checked);
  };

  const columns = [
    {
      title: 'Part Number',
      dataIndex: 'partNumber',
      sorter: (a, b) => a.partNumber.length - b.partNumber.length,
    },
    {
      title: 'Work Ticket Number',
      dataIndex: 'workTicketNumber',
      sorter: (a, b) => a.workTicketNumber.length - b.workTicketNumber.length,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: (a, b) => a.status.length - b.status.length,
      render: (text, record) => (
        <span
          style={{
            backgroundColor: record.backGroundColor,
            color: record.textColor,
            padding: '4px 8px',
            borderRadius: '4px',
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      sorter: (a, b) => a.quantity.length - b.quantity.length,
    },
    {
      title: 'Cell Number',
      dataIndex: 'cellNumber',
      sorter: (a, b) => a.cellNumber.length - b.cellNumber.length,
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'id',
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            {/* <Link className="confirm-text p-2" onClick={() => handleDeleteClick(record.id)}>
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link> */}
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive product-list">
      {isLoading && <LoadingSpinner />}
      <Table columns={columns} dataSource={filteredData} />
    </div>
  );
};

export default ProductionTable;
